  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

              <h4 style="text-align:center;"> <span> Solicitações de Mudança de Turma , Classe , e Curso  </span></h4>

<div class="text-center">
  <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

 <v-container fluid>
    <v-row align="center">
       <v-col class="d-flex" cols="3" sm="4">

        <v-select
          v-model="operacao"
          :items="Operacoes"
          item-value="id"
          item-text="descricao"
          :rules="ruleRequired"
          @change="SelecionaEntidade()"
          label="Filtro por Operação"
        ></v-select>

      </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

      <v-dialog
      v-model="dialog"
      max-width="410"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>  Alerta</v-card-title>

        <v-card-text>
          Ao efectuar a Transferência , <strong>não será possivel</strong> inverter a operação!
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="SaveTransferencia()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
            :headers="headers"
            :items="mudancas"
          >

      </v-data-table>

  </v-container>

</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    mudancas: [],
    turmasAll: [],
    classe: 0,
    disabilita: false,
    dialog: false,
    operacao: '',
    turma: 0,
    turmasFiltered: [],
    select1: null,
    estudante_pendente: [],
    pesquisa_parameto: null,
    idinstproveniente: 0,
    estudante_dados: [],
    disabilita_ano: true,
    funcionarios: [],
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    Operacoes: [
      { id: 1, descricao: 'Mudança de Classe' },
      { id: 2, descricao: 'Mudança de Turma' },
      { id: 3, descricao: 'Mudança de Curso' }
    ],

    headers: [
      { text: 'Nome do Estudante ', value: 'nome' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Descrição Operação', value: 'descricao_operacao' },
      { text: 'Status', value: 'status' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },
  methods: {

    async initialize (searchInDb) {
      try {
        this.isLoading = true

        this.mudancas = await axios
          .get('/ListarMudancas')
          .then(res => res.data)
        this.isLoading = false
        console.log(this.mudancas)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaEntidade () {
      setTimeout(() => {
        this.estudante_pendente = this.solicitacoes_pendentes.filter(t => t.idMatricula === this.select1)
        if (this.estudante_pendente.length) // Seta os campos
        {
          this.classe = this.estudante_pendente[0].idanoacademico
          this.idinstproveniente = this.estudante_pendente[0].idinstituicaoProveniencia
          this.SelecionaAluno()

          setTimeout(() => {
            if (this.estudante_dados.length) {
              if (this.estudante_dados[this.estudante_dados.length - 1].resultado === 'Transita') {
                let idano_academico = parseInt(this.estudante_pendente[0].idanoacademico)
                this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.estudante_pendente[0].idCurso && t.idAno_Academico == (idano_academico + 1))
              } else { this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.estudante_pendente[0].idCurso && t.idAno_Academico == (this.estudante_pendente[0].idanoacademico)) }
            }
          }, 1000)
        }
      }, 0)
    },

    async  SaveTransferencia () {
      let obj_turma = this.turmasFiltered.filter(t => t.pkTurma === this.turma) // Turma selecionada

      //= ================================ VERIFICA SE O ALUNO =============================================================

      try {
        this.progresso = true
        this.Pessoas = await axios
          .get('/Verifica_inscricao/' + this.select1)
          .then(res => res.data)
        this.progresso = false
        console.log(this.Pessoas)
      } catch (error) {
        this.progresso = false
      }

      //= =============================== FIM DESSA VERIFICAÇÃO ============================================================
      if (this.Pessoas.length && obj_turma.length) // Se encontrar ==== Apenas Actaliza a instituição em Pessoa e fkTurma , idTurma e outros em inscrição na turma
      {
        let dados = {
          idmatricula: this.Pessoas[0].idMAtricula,
          fkTurma: obj_turma[0].pkTurma,
          idturma: obj_turma[0].idTurma,
          pkinscricao_na_turma: this.Pessoas[0].pkInscricao_na_turma,
          inscrito: 1
        }

        try {
          this.progresso = true
          let msg = await axios
            .post('/Actualiza_Pessoa_transferencia', dados)
            .then(res => res.data)
          this.progresso = false
          this.Limpar(msg)
          this.text = msg
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        } catch (error) {
          this.progresso = false
        }
        this.dialog = false
      } else // Se não tiver feito ja uma inscrição , lhe é feito uma nova inscrição - ( confirmação de matricula )
      {
        if (obj_turma) {
          // Faz a nova inserção
          const valores =
                    {
                      idmatricula: this.select1,
                      idturma: obj_turma[0].idTurma,
                      pkPessoa: this.estudante_dados[0].pkPessoa,
                      idanolectivo: (obj_turma[0].idAnoLectivo === null) ? 10 : obj_turma[0].idAnoLectivo,
                      pkTurma: obj_turma[0].pkTurma,
                      idcurso: obj_turma[0].idCurso,
                      bi: this.estudante_dados[0].bi,
                      idanoacademico: obj_turma[0].idAno_Academico,
                      resultado: (this.estudante_dados[this.estudante_dados.length - 1].resultado === 'Transita') ? 1 : 0,
                      descricao_resultado: this.estudante_dados[this.estudante_dados.length - 1].resultado,
                      fromtransferencia: 1
                    }

          try {
            this.progresso = true
            let cor_mensagem = 'msgError'
            let msg = await axios
              .post('/confirmacaoInsertOrUpdate', valores)
              .then(res => res.data)

            if (msg.length) {
              cor_mensagem = 'msgError'
              this.text = 'Ocorreu um erro ao tentar Confirmar a transferência'
            } else {
              cor_mensagem = 'msgSucess'
              this.text = 'Transferência Aceite com sucesso'
              this.Limpar()
            }
            this.progresso = false
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': cor_mensagem, 'timeout': 8000 })
          } catch (error) {
            this.progresso = false

            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }

          this.dialog = false
        }
      }

      //= ==========================================================================================================================
    },

    Limpar (msg) {
      const index = this.solicitacoes_pendentes.indexOf(this.estudante_pendente)
      this.solicitacoes_pendentes.splice(index, 1)
      this.select1 = ''
      this.disabilita = true
      this.turma = ''
      this.estudante_pendente = []
      this.estudante_dados = []
    },

    async save () {
      this.dialog = true
    },

    async verifica_Inscricao () {

    },

    async Actualiza_Dados_Transferencia (obj_turma) {
      let dados = {
        idmatricula: this.Pessoas[0].idMAtricula,
        fkTurma: obj_turma[0].pkTurma,
        idturma: obj_turma[0].idTurma,
        pkinscricao_na_turma: this.Pessoas[0].pkInscricao_na_turma,
        inscrito: 0
      }

      try {
        this.progresso = true
        let msg = await axios
          .post('/Actualiza_Pessoa_transferencia', dados)
          .then(res => res.data)
        this.progresso = false
        this.Limpar(msg)
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
      } catch (error) {
        this.progresso = false
      }
    },

    async CarregaAlunos () {
      if (this.select_anolectivo != null) {
        try {
          this.progresso = true
          this.Pessoas = await axios
            .get('/pessoaFind/' + this.select_anolectivo)
            .then(res => res.data)
          this.progresso = false
          console.log(this.Pessoas)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async SelecionaAluno () {
      if (this.select1 != null && this.idinstproveniente !== 0) {
        // CarregaInscrição na turma
        try {
          this.estudante_dados = await axios
            .get('/PesquisaInstituicaoEspecifica/' + this.select1 + '/' + this.idinstproveniente)
            .then(res => res.data)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll')
          .then(res => res.data)
        console.log(this.turmasAll)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }

  }

}

</script>
